import { envEnum } from './envEnum';

export interface Environment {
    production: boolean;
    server: string;
    label: string;
    env: envEnum;
}

export const environment: Environment = {
    production: false,
    server: 'https://dev-api-saleshub.aeins.de',
    label: 'Lokal',
    env: envEnum.dev,
};
